import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useNavigation } from '../hooks/useNavigation';

/**
 * Componente para proteger rutas basado en roles
 * @param {Object} props - Las props del componente
 * @param {React.ReactNode} props.children - Componente hijo a renderizar si tiene acceso
 */
const ProtectedRoute = ({ children }) => {
  const { canAccessRoute, getDefaultRoute, isSupervisor } = useNavigation();
  const location = useLocation();

  // Verificar si el usuario puede acceder a la ruta actual
  const hasAccess = canAccessRoute(location.pathname);

  // Si no tiene acceso, redirigir a la ruta por defecto
  if (!hasAccess) {
    return <Navigate to={getDefaultRoute} replace />;
  }

  // Si tiene acceso, renderizar el componente hijo
  return children;
};

export default ProtectedRoute;